import React from 'react';
import icCheck1 from 'Assets/img/sign/ic_check_circle_blue.png';
import icCheck2 from 'Assets/img/sign/ic_check_circle_blue@2x.png';
import icCheck3 from 'Assets/img/sign/ic_check_circle_blue@3x.png';
import { getImageSet } from 'Util/DataUtils';
import IntlMessages from 'Util/IntlMessages';
import BasicButton from '../../common/BasicButton';
import { useMutationQuery } from 'Api/hooks/useMutationQuery';
import { useDispatch } from 'react-redux';
import { signInUser } from 'Actions/AuthActions';
import { useNavigate } from 'react-router-dom';
import { useError } from 'Api/hooks/useError';

const icCheck = getImageSet([icCheck1, icCheck2, icCheck3]);

const CompleteSection = ({ data: propsData }) => {
  const { showErrorPopup } = useError();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { mutate } = useMutationQuery({
    method: 'post',
    url: '/auth/login',
    options: {
      onSuccess: async ({ data }) => {
        dispatch(signInUser(data, navigate));
      },
      onError: error => {
        showErrorPopup({ text: error?.response?.data?.message });
      },
    },
  });
  if (!propsData) return <></>;
  const { phone, phoneCountry, password, companyName } = propsData;

  return (
    <div className="inner-container" style={{ paddingLeft: '20px', paddingRight: '20px', gap: '80px' }}>
      <div className="join-complete-wrapper">
        <img {...icCheck} alt="check" />
        <span className="join-complete-title">
          <IntlMessages id="signIn.join.button" />
        </span>
        <div className="join-complete-contents">
          <IntlMessages id="signIn.join.complete.message" values={{ companyName }} />
        </div>
      </div>
      <BasicButton
        label="signIn.join.complete.button"
        onClick={() => {
          mutate({ phone, phoneCountry, password });
        }}
        style={{ backgroundColor: '#0567F9' }}
      />
    </div>
  );
};

export default CompleteSection;
